<template>
  <div class="grid grid-cols-1 row-gap-12">
    <SpaceTypePicker2 :selected="type" @change="type = $event"/>
    <BaseInput v-model.trim=" $v.title.$model"
               :label="$t('nameLabel')"
               :class="{'--error': $v.title.$error }">
      <template v-slot:errors>
        <div class="error" v-if="!$v.title.required">{{ $t('errors.required') }}</div>
      </template>
    </BaseInput>
    <BaseSelect v-model="currency_id"
                :options="currenciesWOCrypto"
                :label="`name_${$i18n.locale}`"
                :select-label="$t('currencyLabel')"
                group-label="title"
                group-values="list"
                track-by="id"
                :allow-empty="false"
                :group-select="false"
                :searchable="true"
                :show-labels="false"
                @input="currency_id = $event"/>
    <BaseButton @click="create" :loading="loading"
                theme="red" class="w-full">
      {{ $t('create') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import {required} from "vuelidate/lib/validators";
import {mapActions, mapGetters, mapState} from "vuex";
import SpaceTypePicker2 from "@/components/common/SpaceTypePicker/SpaceTypePicker2";

export default {
  name: "CreateSpaceForm",
  components: {SpaceTypePicker2, BaseButton, BaseSelect, BaseInput},
  data() {
    return {
      type: 1,
      title: this.$i18n.locale === 'en' ? 'My finances' : 'Мои финансы',
      currency_id: null,
      loading: false
    }
  },
  validations: {
    title: {
      required,
    }
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('cabinet/currencies', ['currenciesSortedList']),
    currenciesWOCrypto() {
      return this.currenciesSortedList.map(group => ({
        ...group,
        list: group.list.filter(currency => !currency.is_crypto)
      }));
    }
  },
  methods: {
    ...mapActions('cabinet/currencies', ['getCurrencies']),
    ...mapActions('space', ['createSpace', 'getActiveSpaces']),
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
    async create() {
      if (this.loading) return false;
      this.loading = true;
      let data = {
        type: this.type,
        title: this.title,
        currency_id: this.currency_id.id
      }
      try {
        const res = await this.createSpace(data)
        if (res.body.success) {
          await this.getActiveSpaces()
          await this.setUserPrimarySpaceId(res.body.data.id);
          this.$router.push({name: 'home'});
        } else {
          console.log(res)
        }
      } catch (err) {
        console.log(err);
        this.$toasted.error('Ошибка! Что-то пошло не так...');
      } finally {
        this.loading = false;
      }

    },
  },
  watch: {
    currenciesSortedList: {
      immediate: true,
      handler(val) {
        if (!!val.length) {
          this.currency_id = this.currenciesSortedList[0].list[0]
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        nameLabel: 'Workspace name',
        currencyLabel: 'Base currency',
        create: 'Create'
      },
      ru: {
        nameLabel: 'Название пространства',
        currencyLabel: 'Базовая валюта',
        create: 'Создать'
      }
    }
  }

}
</script>